<!--
Placeholder component for StyleColorQuickActions.
-->
<template>
  <div
    class="button-container"
    :class="[size, orientation]">
    <div
      v-for="index in 2"
      :key="index"
      class="button"
      :class="size">
      &nbsp;
    </div>
  </div>
</template>

<script setup>
defineProps({
  orientation: {
    type: String,
    default: 'vertical',
    validator: value => ['horizontal', 'vertical'].includes(value)
  },
  size: {
    type: String,
    default: 'medium',
    validator: value => ['x-large', 'large', 'medium', 'small', 'tiny'].includes(value)
  }
})
</script>

<style lang="scss" scoped>
@import './StyleColorQuickActions.scss';

.button {
  width: var(--button-size);
  height: var(--button-size);
  background-color: darken($origami, 2%);
  border-radius: 50%;
  border: 1px solid $ash;
  padding: 0px;
}
</style>
